import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { useAction } from 'app/hooks';
import { actions as modalsActions, modalTypes } from 'ducks/modals';
import { actions as clientsActions } from 'ducks/clients';
import { Button } from 'components';

const ActivateClient = memo((props) => {
  const { client } = props;
  const {
    id: clientId,
    user: { id: userId },
  } = client;
  const activateClient = useAction(clientsActions.activateClient);
  const showModal = useAction(modalsActions.showModal);

  const onClick = useCallback(() => {
    showModal(modalTypes.CONFIRMATION_MODAL, {
      onOk: () => activateClient(userId, clientId),
    });
  }, [userId, clientId, activateClient, showModal]);

  return (
    <Button variant="outlined" size="small" label="app:activate" onClick={onClick} marginLeft />
  );
});

ActivateClient.propTypes = {
  client: PropTypes.object.isRequired,
};

export default ActivateClient;
